export default {
    disciplineTypes:      { method: 'get',    url: 'discipline_types' },
    createDisciplineType: { method: 'post',   url: 'discipline_types'},
    updateDisciplineType: { method: 'put',    url: 'discipline_types/{id}'},
    deleteDisciplineType: { method: 'delete', url: 'discipline_types/{id}'}
}